import { Component, Inject, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NotificationsService } from 'angular2-notifications';
import { EditImageDialogEditformsComponent } from '../../../../modules/GET_NEW_UI/edit-digital-forms/edit-image-dialog-editforms/edit-image-dialog-editforms.component';
import { PIPImplementImagesVM } from '../../../../modules/GET_NEW_UI/entities/global/model';
import { ProgramImprovementService } from '../../../../modules/GET_NEW_UI/services/program-improvement.service';
import { FileReaderEvent } from '../../../../shared/models/FileReader';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-product-improvment-asset-viewimage',
  templateUrl: './product-improvment-asset-viewimage.component.html',
  styleUrls: ['./product-improvment-asset-viewimage.component.scss']
})
export class ProductImprovmentAssetViewimageComponent implements OnInit {

  image: string;
  Id:number
  loadingPhoto: boolean = true;
  PIPImplementId

  constructor(private _dialogRef: MatDialogRef<ProductImprovmentAssetViewimageComponent>,
    @Inject(MAT_DIALOG_DATA) private _data: any,private _sanitizer: DomSanitizer,
    private _dialog: MatDialog, private _programImprovementService :ProgramImprovementService,
    private _notify: NotificationsService,) { }

  ngOnInit() {
    this.image = this._data.image;
    this.Id = this._data.Id;
    this.PIPImplementId=this._data.PIPImplementId
    console.log(this.image, this.Id)
    this.loadingPhoto=true;
  }

  getImage(image: string) {
    return this._sanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64,' + image);
}

onNoClick(): void {
  this._dialogRef.close();
}

EditedImage
openEditImageComponent() {
  const dialogRef = this._dialog.open(EditImageDialogEditformsComponent, {
    data: {
      photoWithExt: 'data:image/*;base64,' + this.image,
      QuestionId: this.Id
    }
  });
  dialogRef.afterClosed().subscribe(res => {
    if (res != null) {
      this.image = res.photo;
       this.EditedImage =  this.image

       let params= new PIPImplementImagesVM()
       params.Images=this.image
       params.Id=this.Id

this._programImprovementService.EditProductImprovementAssetImages(params).subscribe(res=>{
if(res>0){
  this._notify.success("Image has been successfully Edited");
  
}
})
      
    
      
    }
  });
}

deletePhoto()
{
let model =new PIPImplementImagesVM();
    model.Id=this.Id
    model.Images=this.image
    model.PIPImpId=this.PIPImplementId

    this._programImprovementService.AddDeletePIPImplementImages(model).subscribe(res=>{
      if(res=true){
        this._notify.success('Image Successfully deleted');    
        this._dialogRef.close(); 
      }
     
      })
}





// onSelectPhoto(event: any) {
//   if (event.target.files && event.target.files[0]) {
//     const reader = new FileReader();
//     reader.readAsDataURL(event.target.files[0]);
//     reader.onload = (event: FileReaderEvent) => {

//       const imageUrl = (event.target.result);
//       //resize photo
//       this.compressImage(imageUrl).then((res: string) => {
//         // console.log("imageUrl", res)
//         if (res) {
//          //console.log('res', res)

//           //photo.NewPhoto =  this.uploadPhoto(res.split(',')[1]);
//          // this.uploadPhoto(res.split(',')[1]);
//           this.ReplacePhoto(res.split(',')[1]);
//         }
//       })
//       //this.uploadPhoto(event.target.result.split(',')[1]);
//     };
//   }
// }
onSelectPhoto(event: any) {
  if (event.target.files && event.target.files[0]) {
    const reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);

    reader.onload = (event: ProgressEvent<FileReader>) => { // Correct event type
      if (event.target && event.target.result) {
        const imageUrl = event.target.result as string; // Cast to string

        // Resize photo
        this.compressImage(imageUrl).then((res: string) => {
          if (res) {
            // Replace the photo with the compressed version
            this.ReplacePhoto(res.split(',')[1]); // Send only base64 data
          }
        });
      }
    };
  }
}

private compressImage(src) {
  return new Promise((res, rej) => {
    const img = new Image();
    img.src = src;
    img.onload = () => {
      const elem = document.createElement('canvas');

      let width, height;
      width = img.width;
      height = img.height;

      console.log('width', width)
      console.log('height', height)

      var ratio = height / width; //cal aspect ratio
      let imageWidth = 800;//643
      var new_height = imageWidth * ratio; //calculate new height

      elem.width = imageWidth;
      elem.height = new_height;
      const ctx = elem.getContext('2d');
      ctx.drawImage(img, 0, 0, imageWidth, new_height);
      const data = ctx.canvas.toDataURL();
      res(data);
    }
    img.onerror = error => rej(error);
  })
}

ReplacePhoto(newPhoto: string){
  let params= new PIPImplementImagesVM()
  params.Images=newPhoto
  params.Id=this.Id

this._programImprovementService.EditProductImprovementAssetImages(params).subscribe(res=>{
if(res>0){
this._notify.success("Image has been successfully Replaced");
this.image=newPhoto
}
})
}

}
